import cx from "classnames";
import { Icon, EditableText, Text, Flex } from "@theorgchartdev/storybook";
import React, { useState } from "react";
import ActionListItem from "../ActionListItem/ActionListItem";
import { appstr } from "@coreapp/utils/appstr";
import { DeleteCustomChartPopover } from "./DeleteCustomChartPopover";
import { getFileIconInfo } from "./fileIconUtils";

const FileNameTextIcon = ({
  filename,
  parentFolder,
  ext,
  value,
  isSelected = false,
  showActions = true,
  onRename,
  handleFileAction,
  rowIdx
}) => {
  const [keepActive, setKeepActive] = useState(false);

  const getIconProp = (name, title) => {
    return {
      name: name,
      size: "small",
      modifier: "default",
      layout: "default"
    };
  };

  let iconName = "";
  let color = "dark";
  let rainbowMode = false;
  let allowColorChange = false;
  const iconInfo = getFileIconInfo(ext);
  iconName = iconInfo.iconName;
  color = iconInfo.color;
  allowColorChange = iconInfo.allowColorChange;
  if (!iconName) return;

  const canEdit = !parentFolder?.IsLocked();
  const genericPermissionTip = appstr("Generic insufficient permissions");

  const isCustomChart = ["oc5", "ocd"].includes(ext?.toLowerCase());
  const isInTrash = parentFolder?.fFolderName?.toLowerCase() === "trash";

  let fileActions = [
    {
      iconName: "copy",
      tooltipProps: { message: canEdit ? appstr("Copy file") : genericPermissionTip },
      iconProps: {
        dataTestId: `fd-file-copy-${rowIdx}`
      },
      onClick: () => handleFileAction("duplicate", value),
      disabled: !canEdit
    },
    {
      iconName: "arrow-down-to-line",
      tooltipProps: { message: appstr("Download file") },
      iconProps: {
        dataTestId: `fd-file-download-${rowIdx}`
      },
      onClick: () => handleFileAction("download", value)
    }
  ];

  // Only show delete action for custom charts (oc5, ocd)
  if (isCustomChart) {
    fileActions.push({
      content: (
        <DeleteCustomChartPopover
          handleDelete={() => handleFileAction("delete", value)}
          dataTestId={`fd-file-delete-${rowIdx}`}
          onPopoverOpen={() => setKeepActive(true)}
          onPopoverClose={() => setKeepActive(false)}
          isInTrash={isInTrash}
          canEdit={canEdit}
        />
      )
    });
  } else {
    fileActions.push({
      iconName: "trash-can",
      tooltipProps: { message: canEdit ? appstr("Delete file") : genericPermissionTip },
      iconProps: {
        color: "error",
        dataTestId: `fd-file-delete-${rowIdx}`
      },
      onClick: () => handleFileAction("delete", value),
      disabled: !canEdit
    });
  }

  let iconColor = "dark";
  if (rainbowMode || allowColorChange) iconColor = color;
  let iconProps = getIconProp(iconName);
  let baseIconClass = "ocn-file-directory-icon";
  let colorClass = `${baseIconClass}--${iconColor}`;
  let baseTextClass = "ocn-folder-row-text";
  let activeIconClass = isSelected ? "ocn-file-row-active" : colorClass;
  let activeTextClass = isSelected ? "ocn-file-row-active-text" : null;

  const textContent =
    showActions && canEdit ? (
      <EditableText
        size={"small"}
        bold={false}
        text={filename}
        onChange={onRename}
        eventInfo={{ renameFile: value }}
        className="oc-overflow-hidden oc-flex-1"
        customClass={cx(baseTextClass, activeTextClass)}
      />
    ) : (
      <Text className={cx(baseTextClass, activeTextClass)} size={"small"}>
        {filename}
      </Text>
    );
  return (
    <Flex height="41px">
      <div
        className={cx(baseIconClass, activeIconClass, "oc-shrink-0 ")}
        style={{ paddingRight: "4px" }}
      >
        <Icon {...iconProps} />
      </div>
      <div className="oc-flex-1 oc-overflow-hidden">
        <ActionListItem
          className="oc-fill-height"
          contentBefore={textContent}
          actions={showActions ? fileActions : []}
          visible={keepActive ? "always" : "hover"}
        />
      </div>
    </Flex>
  );
};

export default FileNameTextIcon;
